/* eslint-disable no-useless-catch */
import { ROUTES, CUSTOMERID } from 'Utils/constants'
import {
  COTIZACION_SUCCESS,
  COTIZACION_INIT,
  COTIZACION_UPDATE,
  COTIZACION_ADD_PRODUCT,
  COTIZACION_ADD_AMOUNT,
  COTIZACION_ADD_CLIENT,
  COTIZACION_REMOVE_CLIENT,
  COTIZACION_ADD_ADDRESS,
  APPROVE_PRICE_CHANGE,
  COTIZACION_ADD_PDV,
  COTIZACION_QUITAR_ADDRESS,
  COTIZACION_GUARDAR_TYPO_DOCUMENT,
  COTIZACION_ELIMINAR_PRODUCTO,
  COTIZACION_ADD_COMMENT,
  COTIZACION_ADD_AMOUNT_EDIT,
  COTIZACION_ADD_SUCURSAL,
  ADD_COMPANY_COTIZACION,
  COTIZACION_CAMBIO_TIPO,
  ADD_PRICE_CHANGE,
  ADD_SALES_AGENT,
  ADD_CHANNEL,
  MOSTRAR_DESCUENTO,
  MODIFICAR_CLIENTE_CONTADO,
  SET_PRICE_LIST,
  COTIZACION_ADD_CREATED_BY_NAME,
  COTIZACION_UPDATE_PLANID_LINES,
  COTIZACION_UPDATE_WAREHOUSE_LINES,
  ACTION_MODAL_CUSTOMER,
  REMOVED_DATA_CLONE,
  COTIZACION_UPDATE_PROMISED_DATE,
  SET_PDF_OPTION,
  SET_SERVICE_NOTE,
  COTIZACION_TEMPORAL_FULFILLMENT_PLAN,
} from '../types'

import {
  addUpdateSalesDocuments,
  generatePDF,
  listSalesAgents,
  salesRelatedDocuments,
  searchSalesDocumentDetail,
  searchSalesDocuments,
  sendEmailQuote,
  updateDocumentStatus,
  uploadDocumentHistory,
} from 'api/mdl11'
import { uploadFile } from 'api/mdl12'
import { persistor } from '../store'

const buildQuoteHeaderColumn = columns => {
  if (!Array.isArray(columns) || columns.length === 0) {
    return undefined
  }

  return [
    columns.reduce((accumulator, column) => {
      if (column?.ColumnName) {
        accumulator[column.ColumnName] = column.Status ? 1 : 0
      }

      return accumulator
    }, {}),
  ]
}

export const agregarCotizacion = productos => {
  // agregar producto
  const cotizacionAddProduct = product => ({
    type: COTIZACION_ADD_PRODUCT,
    payload: product,
  })
  return async (dispatch, getState) => {
    dispatch(
      cotizacionAddProduct({
        Lines: productos.Lines,
        PromisedDate: productos.PromisedDate,
      })
    )
  }
}

export const agregarCliente = cliente => {
  const cotizacionAddClient = client => ({
    type: COTIZACION_ADD_CLIENT,
    payload: client,
  })

  return async dispatch => {
    try {
      dispatch(
        cotizacionAddClient({
          CustomerId: cliente.id,
          CustomerNameDocument: cliente.customerName,
          CustomerExternalCode: cliente.externalCode,
          CustomerTypeId: cliente.customerType,
          EmailAddress: cliente.customerEmail,
          PriceListId: cliente.priceListId,
          Telephone: cliente.customerPhone,
        })
      )
    } catch (error) {
      throw error
    }
  }
}

export const cotizacionRemoveClient = () => ({
  type: COTIZACION_REMOVE_CLIENT,
})
export const cotizacionAddAmountEdit = amount => ({
  type: COTIZACION_ADD_AMOUNT_EDIT,
  payload: amount,
})
export const activeModalCustomer = action => ({
  type: ACTION_MODAL_CUSTOMER,
  payload: action,
})

export const addAmounts = montos => {
  const cotizacionAddAmount = amount => ({
    type: COTIZACION_ADD_AMOUNT,
    payload: amount,
  })

  return async dispatch => {
    try {
      dispatch(cotizacionAddAmount(montos))
    } catch (error) {
      throw error
    }
  }
}

export const cotizacionReStart = () => ({
  type: COTIZACION_INIT,
})

export const addPriceList = payload => ({
  type: SET_PRICE_LIST,
  payload,
})

export const agregarDireccion = direccion => ({
  type: COTIZACION_ADD_ADDRESS,
  payload: direccion,
})

export const agregarPDV = pdv => ({
  type: COTIZACION_ADD_PDV,
  payload: pdv,
})
export const addSalesAgentFullName = name => ({
  type: COTIZACION_ADD_CREATED_BY_NAME,
  payload: name,
})
export const updateCotizacionCompany = estado => ({
  type: ADD_COMPANY_COTIZACION,
  payload: estado,
})
export const agregarSucursal = sucursal => ({
  type: COTIZACION_ADD_SUCURSAL,
  payload: sucursal,
})
export const updatePlanIdLineas = ({
  fulfillmentPlanId,
  fulfillmentPlanDescription,
  cart,
}) => ({
  type: COTIZACION_UPDATE_PLANID_LINES,
  payload: {
    cart,
    fulfillmentPlanId,
    fulfillmentPlanDescription,
  },
})
export const updateTemporalFulfillmentPlan = fulfillmentPlan => {
  if (!fulfillmentPlan) {
    return {
      type: COTIZACION_TEMPORAL_FULFILLMENT_PLAN,
      payload: null,
    }
  }

  const { fulfillmentPlanId, fulfillmentPlanDescription } = fulfillmentPlan
  return {
    type: COTIZACION_TEMPORAL_FULFILLMENT_PLAN,
    payload: {
      fulfillmentPlanId,
      fulfillmentPlanDescription,
    },
  }
}

export const updateWarehouseIdLineas = ({
  WarehouseId,
  WarehouseCode,
  WarehouseDescription,
  WarehouseAddress,
}) => ({
  type: COTIZACION_UPDATE_WAREHOUSE_LINES,
  payload: {
    WarehouseId,
    WarehouseCode,
    WarehouseDescription,
    WarehouseAddress,
  },
})

export const cotizacionUpdate = cotizacion => ({
  type: COTIZACION_UPDATE,
  payload: cotizacion,
})

export const cotizacionChangeType = tipo => ({
  type: COTIZACION_CAMBIO_TIPO,
  payload: tipo,
})

export const addComment = c => ({
  type: COTIZACION_ADD_COMMENT,
  payload: c,
})

export const addChannel = channel => ({
  type: ADD_CHANNEL,
  payload: channel,
})

export const guardarCotizacion = (
  currentQuotation,
  props,
  setIsErrorAddressModal,
  setMessageAddressModal,
  setIsLoading,
  action = 'reload', // 'create' or 'update'
  onAfterSave = null
) => {
  const cotizacionSave = quotation => ({
    type: COTIZACION_SUCCESS,
    payload: {
      DocumentTypeId: currentQuotation.DocumentTypeId,
      QuoteHeader: {
        ...quotation.SalesDocumentInfo,
        Column:
          buildQuoteHeaderColumn(currentQuotation?.Columns) ||
          quotation.SalesDocumentInfo?.Column ||
          currentQuotation?.QuoteHeader?.Column,
      },
    },
  })

  return async dispatch => {
    try {
      setIsLoading(true)
      const isCreateQuote = !currentQuotation?.QuoteHeader?.DocumentNumber
      // A cash customer quote must not keep any CustomerId (only its ODV
      // gets the cash customer guid), so the guid is normalized to null.
      const quoteHeader = currentQuotation?.QuoteHeader
      const customerId = quoteHeader?.CustomerId
      const isCountedCustomer =
        !customerId || customerId.toUpperCase() === CUSTOMERID
      // The endpoint keeps the stored value of any field it does not receive,
      // so the cash customer phone is always sent: the entered one, or null
      // to clear a phone left over from a previous registered customer
      const countedCustomerPhone =
        quoteHeader?.Telephone_Number ||
        quoteHeader?.Cellphone_Number ||
        quoteHeader?.Telephone ||
        null
      const quotationToSave = isCountedCustomer
        ? {
            ...currentQuotation,
            QuoteHeader: {
              ...quoteHeader,
              CustomerId: null,
              Telephone: countedCustomerPhone,
              Telephone_Number: countedCustomerPhone,
              Cellphone_Number: countedCustomerPhone,
            },
          }
        : currentQuotation
      const {
        data: { Data },
      } = await addUpdateSalesDocuments(quotationToSave)

      if (Data) {
        const actionMessage = isCreateQuote ? 'creada' : 'guardada'

        if (onAfterSave) {
          try {
            const hasAfterSaveError = await onAfterSave(Data)
            if (hasAfterSaveError) {
              setIsLoading(false)
              return
            }
          } catch (err) {
            console.error('Error in onAfterSave callback:', err)
            setIsLoading(false)
            setIsErrorAddressModal(true)
            setMessageAddressModal({
              message:
                'La cotización fue guardada, pero ocurrió un error al actualizar los documentos relacionados',
              status: 'error',
            })
            return
          }
        }

        setIsLoading(false)
        setIsErrorAddressModal(true)
        setMessageAddressModal({
          message: `La cotización ha sido ${actionMessage} exitosamente`,
          status: 'success',
        })

        setTimeout(async () => {
          localStorage.setItem(
            'updatedQuote',
            JSON.stringify({
              documentNumber: Data.SalesDocumentInfo?.DocumentNumber,
              timestamp: Date.now(),
            })
          )

          setTimeout(() => {
            localStorage.removeItem('updatedQuote')
          }, 100)

          dispatch(cotizacionSave(Data))

          try {
            await persistor.flush()
          } catch (persistError) {
            console.error(
              'Error persisting saved quotation state:',
              persistError
            )
          }

          if (action === 'editionPage') {
            props.history.push(
              `${ROUTES.editQuoteHeaderId}${Data.SalesDocumentInfo?.DocHeaderId}/${Data.SalesDocumentInfo?.DocumentNumber}`
            )
          }

          if (action === 'reload') {
            window.location.reload()
          }
        }, 2000)
      } else {
        setIsLoading(false)
        setIsErrorAddressModal(true)
        setMessageAddressModal({
          message: '¡Ha ocurrido un error!',
          status: 'error',
        })
      }
    } catch (error) {
      if (error?.code !== 'RELATED_ORDER_PAYMENT_LOAD_ERROR') throw error
      setIsLoading(false)
      setIsErrorAddressModal(true)
      setMessageAddressModal({
        message: error?.message || '¡Ha ocurrido un error!',
        status: 'error',
      })
    }
  }
}

export const saveQuoteColumnsSilent =
  (quotation, columns) => async dispatch => {
    if (!Array.isArray(columns) || columns.length === 0) return
    try {
      const {
        data: { Data },
      } = await addUpdateSalesDocuments({
        ...quotation,
        Columns: columns,
      })
      if (Data) {
        const columnData = buildQuoteHeaderColumn(columns)
        dispatch(
          cotizacionUpdate({
            data: {
              ...quotation.QuoteHeader,
              Column: columnData,
            },
            QuoteHeaderId: quotation.QuoteHeader.QuoteHeaderId,
            requestedAt: Date.now(),
          })
        )
      }
    } catch (err) {
      console.error('Error saving column visibility:', err)
    }
  }

export const updateCotizacion = comment => {
  const addComment = c => ({
    type: COTIZACION_ADD_COMMENT,
    payload: c,
  })

  return async (dispatch, getState) => {
    dispatch(addComment(comment))
    const cotizacion = getState().cotizacion
    cotizacion.QuoteHeader.Comment = comment
    try {
      await addUpdateSalesDocuments(cotizacion)
    } catch (error) {
      throw new Error('ERROR AL GUARDAR: ' + error)
    }
  }
}

export const updatePromisedDate = promisedDate => ({
  type: COTIZACION_UPDATE_PROMISED_DATE,
  payload: promisedDate,
})

export const quitarDireccion = () => ({
  type: COTIZACION_QUITAR_ADDRESS,
})

export const guardarTypeDocument = typoDocument => ({
  type: COTIZACION_GUARDAR_TYPO_DOCUMENT,
  payload: typoDocument,
})

export const eliminarProducto = (
  productId,
  isWarranty = false,
  lineIdentity = {},
  isDummy = false
) => ({
  type: COTIZACION_ELIMINAR_PRODUCTO,
  payload: { productId, isWarranty, isDummy, ...lineIdentity },
})

export const cotizacionPriceChange = negotiation => ({
  type: ADD_PRICE_CHANGE,
  payload: negotiation,
})

export const cotizacionPriceChangeApproval = approvalInfo => ({
  type: APPROVE_PRICE_CHANGE,
  payload: approvalInfo,
})

export const addSalesAgent = payload => ({
  type: ADD_SALES_AGENT,
  payload,
})

export const modificarClienteContado = payload => ({
  type: MODIFICAR_CLIENTE_CONTADO,
  payload,
})

export const mostrarDescuento = payload => ({
  type: MOSTRAR_DESCUENTO,
  payload,
})

export const fetchSearchSalesDocuments =
  (payload, isSearchSaleOrderWeb) => async () => {
    try {
      const response = await searchSalesDocuments(payload, isSearchSaleOrderWeb)
      const { data, status } = response
      if (status === 200 && data?.Data) {
        return data.Data
      }
    } catch (err) {
      return err
    }
  }

export const fetchSalesRelatedDocuments = payload => async () => {
  try {
    const response = await salesRelatedDocuments(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    return err
  }
}
export const fetchUpdateDocumentStatus = payload => async () => {
  try {
    const response = await updateDocumentStatus(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    }
  } catch (err) {
    return err
  }
}

export const fetchDownloadPdf = (payload, setPdfLoading) => async () => {
  try {
    const response = await generatePDF(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      window.open(
        data?.Data?.BlobResponse?.FileUrl,
        '_blank',
        'noopener,noreferrer'
      )
      return data.Data
    }
  } catch (err) {
    throw err
  } finally {
    setPdfLoading(null)
  }
}

export const fetchQuotePDF = payload => async () => {
  try {
    const response = await generatePDF(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data.Data
    } else {
      return 'Error: ' + response
    }
  } catch (err) {
    throw err
  }
}

export const fetchSendEmailQuote = (payload, setEmailLoading) => async () => {
  try {
    const response = await sendEmailQuote(payload)
    const { data, status } = response
    if (status === 200 && data?.PDFResponse) {
      return data
    }
  } catch (err) {
    throw err
  } finally {
    setEmailLoading(null)
  }
}

export const fetchListSalesAgents =
  (payload, setSearch, setSalesAgents, setLoading) => async dispatch => {
    try {
      setLoading(true)
      const response = await listSalesAgents(payload)
      const { data, status } = response
      if (status === 200 && data?.Data) {
        setSalesAgents(data.Data)
        setSearch(data.Data)
      }
    } catch (err) {
      throw err
    } finally {
      setLoading(false)
    }
  }

export const fetchSearchSalesDocumentDetail = payload => async () => {
  try {
    const response = await searchSalesDocumentDetail(payload)
    const { data, status } = response
    if (status === 200 && data?.Data) {
      return data
    }
  } catch (err) {
    throw err
  }
}

export const fecthUploadFile = (payload, options) => async () => {
  try {
    const response = await uploadFile(payload, options)
    const { data, status } = response
    if (status === 200 && data?.data) {
      return data
    } else {
      return data
    }
  } catch (err) {
    // throw err;
    return err
  }
}
export const fetchUploadDocumentHistory = payload => async () => {
  try {
    const response = await uploadDocumentHistory(payload)
    const { data, status } = response
    if (status === 200 && data?.data) {
      return data
    } else {
      return data
    }
  } catch (err) {
    // throw err;
    return err
  }
}

export const setPdfOption = (option, value) => ({
  type: SET_PDF_OPTION,
  payload: { option, value },
})

export const setServiceNote = note => ({
  type: SET_SERVICE_NOTE,
  payload: note,
})

export const removedDataClone = () => ({
  type: REMOVED_DATA_CLONE,
})
